import React from "react";

import SearchNoResults from "components/SearchNoResults";
import NoContent from "components/NoContent/NoContent";

import useStyles from "./styles";

interface IProps {
  isSearchResults: boolean;
  searchValue: string;
  message: string;
  onClearSearch?: () => void;
}

const DataAbsenceView = (props: IProps) => {
  const { isSearchResults, searchValue, onClearSearch, message } = props;

  const classes = useStyles();

  if (isSearchResults) {
    return (
      <SearchNoResults value={searchValue} onClearSearch={onClearSearch} />
    );
  }

  return <NoContent className={classes.noWorkouts}>{message}</NoContent>;
};

export default React.memo(DataAbsenceView);
